import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("holistor_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on expired/invalid session: clear token and bounce to login
// (only when on a protected route, to avoid disturbing public/landing pages).
// 401 = session expired/invalid; 403 on the admin panel = session is not (or no
// longer) an admin session -> treat it like an expired admin session.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const path = window.location.pathname;
    if (status === 401) {
      localStorage.removeItem("holistor_token");
      if (path.startsWith("/app") || path === "/admin") {
        window.location.replace(path === "/admin" ? "/admin/login" : "/registro");
      }
    } else if (status === 403 && err.response?.data?.detail?.code === "TYC_REQUIRED") {
      window.dispatchEvent(new Event("tyc-required"));
    } else if (status === 403 && path === "/admin") {
      localStorage.removeItem("holistor_token");
      window.location.replace("/admin/login");
    }
    return Promise.reject(err);
  }
);

export function setToken(token) {
  if (token) localStorage.setItem("holistor_token", token);
  else localStorage.removeItem("holistor_token");
}

export function getToken() {
  return localStorage.getItem("holistor_token");
}

export function formatApiError(detail) {
  if (detail == null) return "Ocurrió un error. Intentá de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (v) => {
  const n = Number(v || 0);
  return "$ " + n.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const pct = (v) => (Number(v || 0) * 100).toLocaleString("es-AR", { maximumFractionDigits: 2 }) + "%";

// Smart AR/US number parsing: accepts 100.254.987,65 · 100254987,65 · 100,254,987.65 · 100254987.65
export function parseAR(v) {
  if (typeof v === "number") return v;
  if (v == null || String(v).trim() === "") return 0;
  let s = String(v).trim().replace(/[^0-9.,\-]/g, "");
  if (s === "" || s === "-") return 0;
  const lastComma = s.lastIndexOf(",");
  const lastDot = s.lastIndexOf(".");
  if (lastComma === -1 && lastDot === -1) {
    // only digits
  } else if (lastComma > lastDot) {
    // comma is the decimal separator (AR style) -> remove dots, comma -> dot
    s = s.replace(/\./g, "").replace(",", ".");
  } else {
    // dot(s) without a later comma: multiple dots (1.000.000) are AR thousands separators;
    // a single dot is the decimal separator (US style) -> remove commas
    const dots = (s.match(/\./g) || []).length;
    if (dots > 1 && lastComma === -1) s = s.replace(/\./g, "");
    else s = s.replace(/,/g, "");
  }
  const n = parseFloat(s);
  return isNaN(n) ? 0 : n;
}

export function formatAR(v) {
  if (v == null || v === "") return "";
  const n = typeof v === "number" ? v : parseAR(v);
  return n.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default api;
